var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.7374 5.03534C24.0297 5.03534 24.399 6.2354 23.522 7.20468L13.5984 18.1899C12.7215 19.1592 11.2445 19.2515 10.3675 18.2822L0.490055 7.15853C-0.386914 6.18925 -0.0638199 5.03534 1.27471 5.03534H22.7374Z","fill":"currentColor"}));
}

CaretDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
